import { render } from "./CardRemittances.vue?vue&type=template&id=3a33ef4a&scoped=true&ts=true"
import script from "./CardRemittances.vue?vue&type=script&lang=ts"
export * from "./CardRemittances.vue?vue&type=script&lang=ts"

import "./CardRemittances.vue?vue&type=style&index=0&id=3a33ef4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a33ef4a"]])

export default __exports__